var cov_1ft6vj8x6c = function () {
  var path = "/Users/spana/SHEIN/shineout/src/InputTitle/index.ts",
      hash = "fc80ba9a1ced10ff9e4b1464e0d8d27d32dfff25",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/InputTitle/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import InputTitle from './inputTitle';
export default InputTitle;